import React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import InfoIcon from '@material-ui/icons/Info';
import EditIcon from '@material-ui/icons/Edit';
import Button from '@material-ui/core/Button';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';


const ITEM_HEIGHT = 48;


const styles = theme => ({
  fab: {
    margin: theme.spacing.unit * 2,
  },
  absolute: {
    position: 'absolute',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 3,
  },
});

class NodeButtonOptions extends React.Component {
  state = {
    anchorEl: null,
  };

  constructor(props){
    super(props);
    this.showInformation = this.showInformation.bind(this);
    this.editInformation = this.editInformation.bind(this);
  }

  handleClick = event => 
  {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  cloneNode = () =>{
    this.props.cloneNode(this.props.node, this.props.path);
    this.handleClose();
  }


  showInformation(){
    this.handleClose();
    this.props.showInformation(this.props.node);
  }

  editInformation(){
    this.handleClose();
    this.props.editInformation(this.props.node, this.props.path);
  }

  render() 
  {
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const { classes } = this.props;

    return (
      <div style={{padding:0, margin:0, position:'relative', display:'inline-block' }}>
        <Button size="small" onClick={this.handleClick} style={{backgroundColor:'#BDBDBD', color:'white'}} className={this.props.buttonClass} aria-label="More">
          <MoreVertIcon style={{borderRadius:'none'}} />
        </Button>
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={this.handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: 200,
            },
          }}
        >
            <MenuItem key={"Information"} onClick={this.showInformation}>
              <ListItemIcon className={classes.icon}>
                <InfoIcon />
              </ListItemIcon>
              <ListItemText classes={{ primary: classes.primary }} inset primary="Information" />
            </MenuItem>
            <MenuItem key={"Edit"} onClick={this.editInformation}>
              <ListItemIcon className={classes.icon}>
                <EditIcon />
              </ListItemIcon>
              <ListItemText classes={{ primary: classes.primary }} inset primary="Edit" />
            </MenuItem>
        </Menu>
      </div>
    );
  }
}


export default withStyles(styles)(NodeButtonOptions);


// WEBPACK FOOTER //
// ./src/features/wbs/NodeButtonOptions.js